import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchBlogs(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/blogs', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchBlog(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/blog/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateBlog(ctx, { id, blogData }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/blog/${id}/update`, blogData)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        changeStateBlog(ctx, { id, state }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/blog/${id}/change-state`, { state })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteBlog(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/blog/${id}/delete`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}